import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DatiqTableModule } from '../../datiq-table.module';
import { DatiqCellActionComponent } from '../datiq-cell-action';
import { DatiqCellHeaderSortBy, IDatiqCellHeaderSort } from '../datiq-cell-header-sort';
import { DatiqCellMenuComponent } from '../datiq-cell-menu';
import {
    DatiqCellSelectComponent,
    IDatiqCellSelectChange,
} from '../datiq-cell-select';
import { IqAction } from '../models';
import {
    IDatiqTableRow,
    IDatiqTableRowColumns,
    emptyDatiqTableRow,
} from './models';

@Component({
    selector: 'datiq-table-row',
    standalone: true,
    imports: [
        CommonModule,
        DatiqTableModule,
        DatiqCellActionComponent,
        DatiqCellMenuComponent,
        DatiqCellSelectComponent,
    ],
    templateUrl: './datiq-table-row.component.html',
    styleUrls: ['./datiq-table-row.component.scss'],
})
export class DatiqTableRowComponent {
    @Input()
    settings: IDatiqTableRow = emptyDatiqTableRow;

    @Input()
    rows: IDatiqTableRow;

    @Output()
    sortedColumn: EventEmitter<IDatiqCellHeaderSort> =
        new EventEmitter<IDatiqCellHeaderSort>();

    @Output()
    actionFired: EventEmitter<IqAction> = new EventEmitter<IqAction>();

    @Output()
    rowClicked: EventEmitter<IDatiqTableRow> =
        new EventEmitter<IDatiqTableRow>();

    @Output()
    selectChanged: EventEmitter<IDatiqCellSelectChange> =
        new EventEmitter<IDatiqCellSelectChange>();

    sortingColumn: string = '';
    renderTable: boolean = true;

    constructor() {}

    sortColumn(
        headerCell: IDatiqCellHeaderSort,
        column: IDatiqTableRowColumns,
    ) {

        this.sortingColumn = headerCell.label;
        this.sortedColumn.emit(headerCell);
    }

    rowClick(row: IDatiqTableRow) {
        this.rowClicked.emit(row);
    }

    selectChange(select: IDatiqCellSelectChange) {
        this.selectChanged.emit({ ...select, data: this.settings });
    }
}
